import React from 'react';

import Popper from '@mui/material/Popper';
import { Paper } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import ResultsTabs from './ResultsTabs';

const Results = ({
    anchorEl = null,
    clearSearch,
    open = false,
    resultBoxRef,
    searchFieldRef,
    searchQuery = '',
}) => {
    const id = open ? 'global-search-popover' : undefined;

    return (
        <Popper
            anchorEl={anchorEl}
            disablePortal={true}
            id={id}
            open={open}
            placement="top-start"
            sx={{ zIndex: 10000 }}
        >
            <Paper style={{ padding: 3, width: '450px' }}>
                <ResultsTabs
                    clearSearch={clearSearch}
                    myForwardedRef={resultBoxRef}
                    searchFieldRef={searchFieldRef}
                    searchQuery={searchQuery}
                />
            </Paper>
        </Popper>
    );
};

Results.propTypes = {
    anchorEl: PropTypes.object,
    clearSearch: PropTypes.func,
    open: PropTypes.bool,
    resultBoxRef: PropTypes.object,
    searchFieldRef: PropTypes.object,
    searchQuery: PropTypes.string,
};

export default Results;
